import React from 'react';
import './Team.css';

function Team() {
  return (
    <div className="team-container">
      <section className="team-hero-section">
        <h1>Meet Our Team</h1>
        <p>Our team of experts is dedicated to your success.</p>
      </section>

      <section className="team-members-section">
        <h2>Our Team Members</h2>
        <div className="team-grid">
          <div className="team-member">
            <h3>Warren Noubi</h3>
            <p>CIO & Founder</p>
          </div>
          <div className="team-member">
            <h3>Emily Johnson</h3>
            <p>Head of Research</p>
          </div>
          <div className="team-member">
            <h3>Michael Brown</h3>
            <p>Portfolio Manager</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Team;
